import { render, staticRenderFns } from "./EditAttendeeComponent.vue?vue&type=template&id=671eab74&scoped=true"
import script from "./EditAttendeeComponent.vue?vue&type=script&lang=js"
export * from "./EditAttendeeComponent.vue?vue&type=script&lang=js"
import style0 from "./EditAttendeeComponent.vue?vue&type=style&index=0&id=671eab74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671eab74",
  null
  
)

export default component.exports